import React from 'react';
import { HomeIcon } from '@heroicons/react/20/solid';
import { ListBulletIcon } from '@heroicons/react/24/outline';

const EstimateBar = ({ id, name, builder_id}) => {

  // Create a dynamic list of pages with current page highlighted
  const pages = [
    { name: 'Estimate', href: `/b_estimate/${builder_id}/${id}`, current: name === 'Estimate' },
    { name: 'Services & MarkUps', href: `/b_service_markup/${builder_id}/${id}`, current: name === 'markup-service' },
    { name: 'Equipment', href: `/b_equipment/${builder_id}/${id}`, current: name === 'Equipment' },
    // { name: 'Wire', href: `/estimate_wire/${builder_id}/${id}`, current: name === 'Wire' },
    { name: 'Contractor', href: `/estimate_contr/${builder_id}/${id}`, current: name === 'Contractor' },
    { name: 'Notes', href: `/estimate_notes/${builder_id}/${id}`, current: name === 'Notes' },
    { name: 'Miscellaneous', href: `/estimate_misc/${builder_id}/${id}`, current: name === 'Miscellaneous' },
    { name: 'Detail', href: `/estimate_detail/${builder_id}/${id}`, current: name === 'Detail' },
    { name: 'Proposal', href: `/estimate_proposal/${builder_id}/${id}`, current: name === 'Proposal' },
  ];

  return (
    <nav aria-label="Breadcrumb" className="flex border-b border-gray-200 bg-white mb-8">
      <ol role="list" className="mx-auto flex w-full max-w-screen-xl space-x-4 px-4 sm:px-6 lg:px-8">
        <li className="flex">
          <div className="flex items-center">
            <a href="/b_estimate" className="text-gray-400 hover:text-gray-500">
              <ListBulletIcon aria-hidden="true" className="h-5 w-5 flex-shrink-0" />
              <span className="sr-only">Home</span>
            </a>
          </div>
        </li>
        {pages.map((page) => (
          <li key={page.name} className="flex">
            <div className="flex items-center">
              <svg
                fill="currentColor"
                viewBox="0 0 24 44"
                preserveAspectRatio="none"
                aria-hidden="true"
                className="h-full w-6 flex-shrink-0 text-gray-200"
              >
                <path d="M.293 0l22 22-22 22h1.414l22-22-22-22H.293z" />
              </svg>
              <a
                href={page.href}
                aria-current={page.current ? 'page' : undefined}
                className={`ml-4 text-sm font-medium ${page.current ? 'text-blue-700 px-3 py-1 rounded' : 'text-gray-500 hover:text-gray-700'}`}
              >
                {page.name}
              </a>
            </div>
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default EstimateBar;
